export default __webpack_public_path__ + "static/media/close.16edb452.svg";